package com.sweetlime.bingeamigo.presentation.ui

import androidx.compose.ui.graphics.Color

enum class AccentSystem { Balanced, Amber, Teal }

data class AccentRoles(
    val tag: Color,
    val tagInk: Color,
    val progress: Color,
    val ring: Color,
    val action: Color,
    val actionInk: Color,
)

object AppAccents {
    fun roles(system: AccentSystem = AccentSystem.Balanced): AccentRoles = when (system) {
        AccentSystem.Amber -> AccentRoles(
            tag = BrandColors.Primary, tagInk = Color(0xFF1A1407),
            progress = BrandColors.Primary, ring = BrandColors.Primary,
            action = BrandColors.Primary, actionInk = Color(0xFF171205),
        )
        AccentSystem.Teal -> AccentRoles(
            tag = BrandColors.Secondary, tagInk = Color(0xFF04231F),
            progress = BrandColors.Secondary, ring = BrandColors.Secondary,
            action = BrandColors.Secondary, actionInk = Color(0xFF042421),
        )
        AccentSystem.Balanced -> AccentRoles(
            tag = BrandColors.Secondary, tagInk = Color(0xFF04231F),
            progress = BrandColors.Secondary, ring = BrandColors.Primary,
            action = BrandColors.Primary, actionInk = Color(0xFF171205),
        )
    }

    val Good = Color(0xFF5FE3B4);  val GoodBg = Color(0x2934D29A)
    val Warn = Color(0xFFFFCE4D);  val WarnBg = Color(0x29FFB800)
    val Behind = Color(0xFFFF8E8E); val BehindBg = Color(0x29FF6A6A)
}
